var Message = require('message');


var MessageList = Backbone.Collection.extend({
    model: Message,
    initialize: function (models, options) {
        this.buffer = options.buffer;
        this.threads = {};
    },
    comparator: function (message) {
        return message.id;
    },
    findByMsgId: function (msgid) {
        return this.findWhere({'msgid': msgid});
    },
    registerThread: function (message) {
        var reply = message.getReply();
        if (reply) {
            this.threads[reply] = true;
        }
    },
    isInThread: function (msgid) {
        return !!this.threads[msgid];
    },
    getThread: function (replyId, excludeEmpty) {
        var msgIds = {};
        return this.filter(function (m) {
            if (excludeEmpty && m.isEmpty()) {
                return false;
            }
            if (m.isSameThread(m, replyId)) {
                if (m.getMsgId()) {
                    msgIds[m.getMsgId()] = true;
                }
                return true;
            } else if (msgIds[m.getReply()]) {
                return true;
            } else if (msgIds[m.getConcatTag()]) {
                return true;
            } else if (msgIds[m.getEdit()]) {
                return true;
            } else if (msgIds[m.getDelete()]) {
                return true;
            }
        }, this);
    },
    lastVisible: function () {
        var last = this.last();
        if (last && last.isEmpty()) {
            last = last.previousVisible();
        }
        return last;
    },
    lastReplyable: function () {
        var last = this.last();
        if (last && !last.isReplyable()) {
            last = last.previousReplyable();
        }
        return last;
    },
    // Filter the message list exclusively
    filterBeforeEid: function (eid, num) {
        // Use find to shortcut the iteration because messages are sorted by eid
        var until = this.find(function (message) {
            return message.id >= eid;
        });
        // Until might not have found anything
        var messages = until ? this.first(this.indexOf(until)) : [];
        if (num) {
            return _.last(messages, num);
        } else {
            return messages;
        }
    }
});


module.exports = MessageList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/messagelist.js
// module id = 7gVv
// module chunks = 1